import { GroupItemInfo } from '@/common/components/organisms/alertListDetail/alertListDetail.types';
import { PlatformType } from '@/common/components/organisms/overviewAlert/overviewAlert.setup';
import { ref } from 'vue';
import { defineStore } from 'pinia';
import { getV9AlertsAlertGroupCount } from '@/api-client/alert/queries/alert-common-v9-controller/alert-common-v9-controller';

export const useAlertGroupStore = defineStore('alertGroup', () => {
  const groupList = ref<GroupItemInfo[]>([]);

  const fetchAlertGroupList = async (
    frameName: string,
    platformTypes?: PlatformType[],
    targetIds?: string[],
  ) => {
    const response = await getV9AlertsAlertGroupCount(
      {
        platformTypes,
        targetIds,
      },
      {
        frameName,
        isPolling: true,
        isTimeout: false,
      },
    );

    groupList.value = response.data?.data ?? [];
  };

  const reset = () => {
    groupList.value = [];
  };

  return {
    groupList,
    fetchAlertGroupList,
    reset,
  };
});
